export default __webpack_public_path__ + "static/media/ambasadorp2big_thumb.0e5431eb.jpg";